export const actions = {
  setUsername: 'SET::USERNAME',
}

export default actions
